var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification-list',{attrs:{"notifications":_vm.$store.state.notifications.slice().reverse(),"full-text":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }